import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m15.4 15.26.25-.26a.35.35 0 0 0-.04-.53l-1.15-.8a.35.35 0 0 0-.43 0l-.37.36a.77.77 0 0 1-1 .14 9.4 9.4 0 0 1-1.56-1.27 9 9 0 0 1-1.24-1.52.76.76 0 0 1 .05-1l.4-.41a.33.33 0 0 0 0-.43l-.8-1.14a.3.3 0 0 0-.24-.14.33.33 0 0 0-.27.09l-.27.31-.05.05c-1.08 1.09.1 3.27 1.74 4.91s3.79 2.82 4.87 1.74z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.277 4.052A9.53 9.53 0 0 1 20.79 8.3a9.7 9.7 0 0 1 .71 3.63 9.46 9.46 0 0 1-13.73 8.48l-4.34 1.14a.6.6 0 0 1-.19 0 .76.76 0 0 1-.72-.95l1.16-4.22A9.47 9.47 0 0 1 12 2.46a9.53 9.53 0 0 1 5.277 1.592M15.33 12.43l1.13.8c.22.153.435.352.57.584a1.83 1.83 0 0 1-.29 2.216l-.36.36-.12.1a2.85 2.85 0 0 1-2 .77c-1.44 0-3.16-.89-4.87-2.61-2.75-2.69-3.36-5.37-1.75-7L8 7.29a1.87 1.87 0 0 1 1.46-.51 1.84 1.84 0 0 1 1.34.78l.79 1.14a1.83 1.83 0 0 1-.16 2.3q.34.442.73.84.401.409.86.75a1.84 1.84 0 0 1 2.31-.16",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }